import controller from './response.controller';
import template from './response.view.html';

let ResponseComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default ResponseComponent;



// WEBPACK FOOTER //
// ./www/components/pay-zone/response/response.component.js